module.exports = "<div class=\"outer-container\">\n  <div class=\"heading\">\n    <h1 class=\"heading--no-margin\">An Error Occurred</h1>\n  </div>\n\n  <div class=\"contents\">\n    <p>\n      Sorry, an error occurred and we were unable to display the page you requested. Please try refreshing the page.\n    </p>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /tmp/build_769bc651/src/app/error/error.component.html
// module id = ../../../../../src/app/error/error.component.html
// module chunks = main